import React, { useState } from 'react';
import axios from 'axios';
import Swal from "sweetalert2";
import { API_URL } from '../components/Constants';

const ResetPassword = () => {
  const [step, setStep] = useState(1);
  const [email, setEmail] = useState('');
  const [code, setCode] = useState('');
  const [newPassword, setNewPassword] = useState('');
  const [confirmPassword, setConfirmPassword] = useState('');
  const [loading, setLoading] = useState(false);
  const [errorMessage, setErrorMessage] = useState('');

  const handleEmailSubmit = (e) => {
    e.preventDefault();
    setLoading(true);
    let data = JSON.stringify({
      "email": email
    });
    let config = {
      method: 'post',
      maxBodyLength: Infinity,
      url: `${API_URL}/send_otp`,
      headers: { 
        'Content-Type': 'application/json'
      },
      data : data
    };
    
    axios.request(config)
    .then((response) => {
      setLoading(false);
      setStep(2);
    })
    .catch((error) => {
      setLoading(false);
      Swal.fire({
        icon: "error",
        title: "Error!",
        text: error?.response?.data?.error,
      })
      console.log(error?.response)
    });
    
  };

  const handleCodeSubmit = (e) => {
    e.preventDefault();
    let userData = {
      userOTP: code
    }
    let config = {
      method: 'post',
      maxBodyLength: Infinity,
      url: `${API_URL}/confirm_otp/${email}`,
      headers: { 
        'Content-Type': 'application/json'
      },
      data: userData
    };
  
    axios.request(config)
    .then((response) => {
      setStep(3);
    })
    .catch((error) => {
      Swal.fire({
        icon: "error",
        title: "Error!",
        text: "OTP confirmation failed",
      })
    });
  };

  const handlePasswordSubmit = (e) => {
    e.preventDefault();
    if(newPassword !== confirmPassword){
        Swal.fire({
          icon: "error",
          title: "Error!",
          text: "Passwords does not match",
        })
    }
    else{
        const Editdata = {
            email: email,
            password: newPassword,
            otp: code,
        }
        let config = {
            method: 'put',
            maxBodyLength: Infinity,
            url: `${API_URL}/reset_password`,
            headers: { 
              'Content-Type': 'application/json'
            },
            data : Editdata
          };
          
          axios.request(config)
          .then((response) => {
            Swal.fire({
              icon: "success",
              title: "Success!",
              text: "Your password has been changed",
            })
            .then(() => {
              window.location.replace('/login');
            });
          })
          .catch((error) => {
            setErrorMessage(error?.response?.data?.error);
          });    
    }
  };

  const removeError = () => {
    setErrorMessage("")
  }

  const renderStep = () => {
    switch (step) {
      case 1:
        return (
          <form onSubmit={handleEmailSubmit} className="logForm">
            <p >Enter your email address, and we will send the verification code to your email.</p>
            <div className="input-div one">
              <div className="div">
                <input
                  type="email"
                  className="form-control"
                  value={email}
                  placeholder='Email'
                  id="email"
                  onChange={(e) => setEmail(e.target.value)}
                  required
                />   
              </div>
            </div>        
           
            {/* <button type="submit">Send Reset Code</button> */}
            <button type='submit' className="Auth-btn" disabled={loading}>
              {loading ? (
                // <span className="spinner" />
                'Requesting...'
              ) : (
                'Request Reset Code'
              )}
            </button>
            
            
          </form>
        );
      case 2:
        return (
          <form onSubmit={handleCodeSubmit} className="logForm">
            <p>Enter the code sent to your email.</p>
            <input
              type="text"
              className="form-control"
              value={code}
              placeholder='Enter confirmation code'
              onChange={(e) => setCode(e.target.value)}
              required
            />
            <button type="submit" className="Auth-btn" >Verify Code</button>
          </form>
        );
      case 3:
        return (
          <form onSubmit={handlePasswordSubmit} className="logForm">
            <p>New Password:</p>
            <input
              type="password"
              className="form-control"
              value={newPassword}
              placeholder='Enter New Password'
              onChange={(e) => setNewPassword(e.target.value)}
              onFocus={removeError}
              required
            />
            <p>Confirm Password:</p>
            <input
              type="password"
              className="form-control"
              value={confirmPassword}
              placeholder='Confirm Password'
              onChange={(e) => setConfirmPassword(e.target.value)}
              onFocus={removeError}
              required
            />
            <button type="submit" className="Auth-btn" >Reset Password</button>
            {errorMessage && <div className="alert alert-danger Errorbox">{errorMessage}</div>}
          </form>
        );
      default:
        return null;
    }
  };

  return (
    <div>
      {renderStep()}
    </div>
  );
};

export default ResetPassword;
